import { useEffect, useState } from 'react';

import { sendApiRequest } from '../services/sendApiRequest';
import {
  resolveMaintenanceModeFromResponse,
  type MaintenanceStatusPayload,
} from '../utils/maintenanceStatus';

export default function useMaintenanceStatus() {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await sendApiRequest<MaintenanceStatusPayload, never>('/maintenance');
        setMaintenanceMode(resolveMaintenanceModeFromResponse(response));
      } catch (fetchError) {
        console.error('Failed to fetch maintenance status:', fetchError);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, []);

  return { loading, maintenanceMode, error };
}
